const removeExtension = filename => {
  return filename.substring(0, filename.lastIndexOf('.')) || filename;
};

export default removeExtension;
